import { PesoAutorreferidoEnum } from 'graphql/types.generated'
import { pesoAutorreferidoRecord } from 'types/enums'

import { RadioGroupField, RadioGroupFieldProps } from './RadioGroupField'
import { recordToSortedRadioOptions } from './utils-field'

type PesoAutorreferidoRadioGroupFieldProps = Readonly<
  Omit<RadioGroupFieldProps<PesoAutorreferidoEnum>, 'label' | 'options'>
>

export function PesoAutorreferidoRadioGroupField(props: PesoAutorreferidoRadioGroupFieldProps) {
  return <RadioGroupField options={options} {...props} />
}

const options = recordToSortedRadioOptions(pesoAutorreferidoRecord)
